(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["barra-progreso-v2"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
  const wrapper = document.querySelector('.descuento-wrapper_BarraProgresoV2');
  if (!wrapper) return;

  const mostrarProcesoCompleto = wrapper.dataset.procesoCompleto === 'true';

  function setState_BarraProgresoV2(estado) {
    wrapper.setAttribute('data-state', estado);
  }

  // ── Actualización parcial: solo el contenido de la barra ──
  function actualizarBarra_BarraProgresoV2() {
    const contenido = document.getElementById('barra-descuento-contenido_BarraProgresoV2');
    if (!contenido) return;

    const sectionId = contenido.dataset.sectionId;
    const url = `${window.location.pathname}?section_id=${sectionId}&t=${Date.now()}`;

    fetch(url)
      .then(res => res.text())
      .then(html => {
        const temp = document.createElement('div');
        temp.innerHTML = html;
        const nuevo = temp.querySelector('#barra-descuento-contenido_BarraProgresoV2');
        const actual = document.getElementById('barra-descuento-contenido_BarraProgresoV2');
        if (nuevo && actual) {
          actual.replaceWith(nuevo);
        }
      })
      .catch(err => console.error('Error actualizando barra:', err));
  }

  // ── Detección inicial de descuento ──
  function esperarYComprobarDescuento_BarraProgresoV2() {
    const MAX_ESPERA = 5000;
    const INTERVALO  = 200;
    let tiempo = 0;

    const intervalo = setInterval(() => {
      tiempo += INTERVALO;
      const tagActivo = document.querySelector('.sc-tag');

      if (tagActivo) {
        clearInterval(intervalo);
        setState_BarraProgresoV2('estado-3');
        sessionStorage.removeItem('descuento_aplicando_BarraProgresoV2');
        return;
      }

      if (tiempo >= MAX_ESPERA) {
        clearInterval(intervalo);
        setState_BarraProgresoV2('estado-1');
        sessionStorage.removeItem('descuento_aplicando_BarraProgresoV2');
      }
    }, INTERVALO);
  }

  // ── Solo comprobamos el ciclo 1→2→3 si el checkbox de proceso completo está activo ──
  if (mostrarProcesoCompleto) {
    esperarYComprobarDescuento_BarraProgresoV2();
  }
  // Si está desactivado, el estado-3 ya viene fijado desde Liquid y no lo tocamos

  // ── Click estado 1 → loader → redirect ──
  const btn  = wrapper.querySelector('.descuento-estado--1_BarraProgresoV2 .btn_BarraProgresoV2');
  const code = btn ? btn.dataset.promo : null;
  if (btn && code) {
    btn.addEventListener('click', () => {
      setState_BarraProgresoV2('estado-2');
      sessionStorage.setItem('descuento_aplicando_BarraProgresoV2', 'true');
      setTimeout(() => {
        window.location.href = `/discount/${code}?redirect=%2Fcart%2F`;
      }, 500);
    });
  }

  // ── Escucha cambios en carrito → actualiza solo la barra ──
  document.addEventListener('input', e => {
    if (
      e.target.closest('form#cart') ||
      e.target.closest('cart-items') ||
      e.target.closest('cart-drawer')
    ) {
      setTimeout(actualizarBarra_BarraProgresoV2, 800);
    }
  });

  document.addEventListener('click', e => {
    const esCantidad =
      e.target.closest('.quantity__button') ||
      e.target.closest("[name='plus']") ||
      e.target.closest("[name='minus']");

    const esEliminar =
      e.target.closest("[name='remove']") ||
      e.target.closest("a[href*='/cart/change']") ||
      e.target.closest('.cart-remove-button') ||
      e.target.closest('.mini-cart__remove') ||
      e.target.closest('.button--tertiary');

    if (esCantidad || esEliminar) {
      setTimeout(actualizarBarra_BarraProgresoV2, 1000);
    }
  });

  document.addEventListener('cart:updated', () => {
    setTimeout(actualizarBarra_BarraProgresoV2, 500);
  });

  // ── MutationObserver → si desaparece .sc-tag → estado-1 (solo si el proceso completo está activo) ──
  const observer = new MutationObserver(() => {
    if (!mostrarProcesoCompleto) return;
    const tagActivo = document.querySelector('.sc-tag');
    if (!tagActivo && wrapper.getAttribute('data-state') === 'estado-3') {
      setState_BarraProgresoV2('estado-1');
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["codigo-promocion-pt"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
      let button = document.querySelector('.codigo-promo-container');
      let code = button.dataset.promo;
      console.log(code);
      button.addEventListener('click', () => {
        window.location.href = `/discount/${code}?redirect=%2Fpt%2Fcart%2F`;
      });
    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["codigo-promocion"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    let button = document.querySelector('.codigo-promo-container');
    let code = button.dataset.promo;
    console.log(code);
    button.addEventListener('click', () => {
      window.location.href = `/discount/${code}?redirect=%2Fcart%2F`;
    });
  });
  } catch(e) { console.error(e); }
})();

})();
